<div class="relative">
  <div class="flex items-center gap-3 cursor-pointer" #matMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu">
    <ig-expand-indicator aria-label="open"
                         [triggerText]="triggerTextMode==='tooltip'?triggerText:''"></ig-expand-indicator>
    <span *ngIf="triggerTextMode==='label'" [ngStyle]="{'color':textColor}">{{ triggerText }}</span>
  </div>

  <mat-menu #menu="matMenu"
            class="ig-iti-details-style-menu">
    <div class="pb-2 pr-5 pl-4">
      <mat-radio-group class="flex flex-col" aria-label="Select an option" [(ngModel)]="currentItinerary.mapStyle"
                       igClickStopPropagation>
        <mat-radio-button value="dark">Dark</mat-radio-button>
        <mat-radio-button value="light" class="">Light</mat-radio-button>
      </mat-radio-group>

      <mat-checkbox class="mb-2" [(ngModel)]="applyToAll" igClickStopPropagation>Apply to all itineraries
      </mat-checkbox>

      <ig-button cls="w-full" (trigger)="setStyle($event, matMenuTrigger)" [isAsync]="true"
                 successText="Update itinerary page style successfully!"
                 igClickStopPropagation>Save
      </ig-button>
    </div>

  </mat-menu>
</div>
